<template>
  <div
    ref="selectComponent"
    class="relative mt-6 flex w-full flex-col rounded-[30px] bg-[#FFFFFF] dark:bg-[#272729] md:mb-10"
  >
    <div class="filter_panel flex w-full justify-center px-4 py-5 md:px-0">
      <div class="flex w-full flex-row divide-x-[1px] lg:w-11/12">
        <div
          @click="handleOpenSelect('selectSortPrice')"
          class="relative flex w-full cursor-pointer items-center px-2 md:px-6"
        >
          <component
            :is="
              defaultNames.selectSortPrice.icon === 'FilterArrowDownIcon'
                ? FilterArrowDownIcon
                : FilterArrowUpIcon
            "
            class="fill-main stroke-main max-sm:h-5"
          />
          <p :class="{ 'ml-4': !verySmallScreen }" class="select-none md:mx-4 md:whitespace-nowrap">
            <template v-if="!smallScreen">
              {{ defaultNames.selectSortPrice.name }}
            </template>
            <template v-else> Price </template>
          </p>
          <arrow-down-narrow-icon class="hidden sm:ml-1 sm:block" />
          <template v-if="selectSortPrice && !isMobile">
            <div
              @click.stop
              class="absolute left-0 top-[56px] !z-[999] flex flex-col overflow-hidden rounded-[30px] bg-[#FFFFFF] dark:bg-[#373739]"
            >
              <div
                v-for="(i, index) in ridesPriceSortOptions"
                :key="i"
                @click.stop="handleSelectSortPrice(index)"
                :class="{ 'w-full bg-[#FFFFFF08]': i.value === filterObj.sort }"
                class="flex items-center px-6 py-[14px]"
              >
                <component
                  :is="i.icon === 'FilterArrowDownIcon' ? FilterArrowDownIcon : FilterArrowUpIcon"
                  class="fill-main stroke-main"
                />
                <span class="ml-4 whitespace-nowrap">{{ i.name }}</span>
              </div>
            </div>
          </template>
        </div>
        <div
          @click="handleOpenSelect('selectSortDate')"
          class="relative flex w-full cursor-pointer items-center px-2 md:px-6"
        >
          <component
            :is="
              defaultNames.selectSortDate.icon === 'FilterArrowDownIcon'
                ? FilterArrowDownIcon
                : FilterArrowUpIcon
            "
            class="fill-main stroke-main max-sm:h-5"
          />
          <p :class="{ 'ml-4': !verySmallScreen }" class="select-none md:mx-4 md:whitespace-nowrap">
            <template v-if="!smallScreen">
              {{ defaultNames.selectSortDate.name }}
            </template>
            <template v-else> Date </template>
          </p>
          <arrow-down-narrow-icon class="hidden sm:ml-1 sm:block" />
          <template v-if="selectSortDate && !isMobile">
            <div
              @click.stop
              class="absolute left-0 top-[56px] !z-[999] flex flex-col overflow-hidden rounded-[30px] bg-[#FFFFFF] dark:bg-[#373739]"
            >
              <div
                v-for="(i, index) in ridesDateSortOptions"
                :key="i"
                @click.stop="handleSelectSortDate(index)"
                :class="{ 'w-full bg-[#FFFFFF08]': i.value === filterObj.sort }"
                class="flex items-center px-6 py-[14px]"
              >
                <component
                  :is="i.icon === 'FilterArrowDownIcon' ? FilterArrowDownIcon : FilterArrowUpIcon"
                  class="fill-main stroke-main"
                />
                <span class="ml-4 whitespace-nowrap">{{ i.name }}</span>
              </div>
            </div>
          </template>
        </div>
        <div
          @click="handleOpenSelect('selectType')"
          class="relative flex w-full cursor-pointer items-center pl-2 md:px-6"
        >
          <p class="select-none md:mr-4">
            {{
              selectedServiceTypes.length > 1
                ? 'Multiple selections'
                : selectedServiceTypes.length === 1
                  ? selectedServiceTypes[0].name
                  : 'Service type'
            }}
          </p>
          <arrow-down-narrow-icon class="hidden sm:ml-1 sm:block" />

          <template v-if="selectType && !isMobile">
            <div
              @click.stop
              class="absolute left-0 top-[56px] !z-[999] flex flex-col overflow-hidden rounded-[30px] bg-[#FFFFFF] dark:bg-[#373739] lg:w-[200px]"
            >
              <div
                v-for="(i, index) in types"
                :key="i"
                :class="{ 'w-full bg-[#FFFFFF08]': i.selected }"
                class="flex items-center px-6 py-[14px]"
                @click="handleSetType(index)"
              >
                <input
                  class="!border-[2px] !border-[#111111] dark:!border-[#FFFFFF]"
                  v-model="i.selected"
                  type="checkbox"
                />
                <span class="ml-4">{{ i.name }}</span>
              </div>
            </div>
          </template>
        </div>
        <div
          @click="handleOpenSelect('selectStatus')"
          class="relative flex w-full cursor-pointer items-center pl-2 md:px-6"
        >
          <p class="select-none md:mr-4">
            {{
              defaultNames.selectStatus.length > 1
                ? 'Multiple selections'
                : defaultNames.selectStatus[0].name
            }}
          </p>
          <arrow-down-narrow-icon class="hidden sm:ml-1 sm:block" />
          <template v-if="selectStatus && !isMobile">
            <div
              @click.stop
              class="absolute left-0 top-[56px] !z-[999] flex flex-col overflow-hidden rounded-[30px] bg-[#FFFFFF] dark:bg-[#373739] lg:w-[200px]"
            >
              <div
                v-for="(i, index) in status"
                :key="i"
                :class="{ 'w-full bg-[#FFFFFF08]': i.checked }"
                class="flex items-center px-6 py-[14px]"
                @click="handleSetStatus(index)"
              >
                <input
                  class="!border-[2px] !border-[#111111] dark:!border-[#FFFFFF]"
                  v-model="i.checked"
                  type="checkbox"
                />
                <span class="ml-4">{{ i.name }}</span>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <div v-if="isMobile" class="mx-4 border-b-[1px] border-b-[#3D4043]"></div>
    <div class="flex w-full flex-row sm:justify-center">
      <div class="w-full py-[14px] pl-4 pr-6 sm:w-[50%]">
        <div class="flex justify-between">
          <span class="mr-1 text-[#878787]">Show:</span>
          <div
            :class="{ 'text-main underline': showPages === i }"
            v-for="i in pages"
            :key="i"
            @click="handleShowPages(i)"
          >
            <span class="cursor-pointer">
              {{ i }}
            </span>
          </div>
          <span
            class="cursor-pointer"
            :class="{ 'text-main underline': showPages === 'all' }"
            @click="handleShowPages('all')"
            >all</span
          >
        </div>
      </div>
    </div>
  </div>
  <div
    v-if="selectStatus && isMobile"
    @click.self="handleCloseSelect"
    class="fixed left-0 top-0 !z-[999] h-full w-full bg-[#000000B2]"
  >
    <div
      class="fixed bottom-0 right-0 w-full rounded-t-[30px] border-t-[1px] border-t-[#3D4043] bg-[#FFFFFF] dark:bg-[#373739]"
    >
      <div
        v-for="(i, index) in status"
        :key="i"
        :class="{ 'w-full dark:bg-[#FFFFFF08]': i.checked }"
        class="flex items-center border-b-[1px] border-b-[#2F3031] px-7 py-[14px]"
        @click.stop="handleSetStatus(index)"
      >
        <input
          class="!border-[2px] !border-[#111111] dark:!border-[#FFFFFF]"
          v-model="i.checked"
          type="checkbox"
        />
        <span class="ml-4">{{ i.name }}</span>
      </div>
    </div>
  </div>
  <div
    v-if="selectType && isMobile"
    @click.self="handleCloseSelect"
    class="fixed left-0 top-0 !z-[999] h-full w-full bg-[#000000B2]"
  >
    <div
      class="fixed bottom-0 right-0 w-full rounded-t-[30px] border-t-[1px] border-t-[#3D4043] bg-[#FFFFFF] dark:bg-[#373739]"
    >
      <div
        v-for="(i, index) in types"
        :key="i"
        :class="{ 'w-full dark:bg-[#FFFFFF08]': i.selected }"
        class="flex items-center border-b-[1px] border-b-[#2F3031] px-7 py-[14px]"
        @click.stop="handleSetType(index)"
      >
        <input
          class="!border-[2px] !border-[#111111] dark:!border-[#FFFFFF]"
          v-model="i.selected"
          type="checkbox"
        />
        <span class="ml-4">{{ i.name }}</span>
      </div>
    </div>
  </div>
  <div
    v-if="selectSortPrice && isMobile"
    @click.self="handleCloseSelect"
    class="fixed left-0 top-0 !z-[999] h-full w-full bg-[#000000B2]"
  >
    <div
      class="fixed bottom-0 right-0 w-full rounded-t-[30px] border-t-[1px] border-t-[#3D4043] bg-[#FFFFFF] dark:bg-[#373739]"
    >
      <div
        v-for="(i, index) in ridesPriceSortOptions"
        :key="i"
        @click="handleSelectSortPrice(index)"
        :class="{ 'w-full bg-[#FFFFFF08]': i.value === filterObj.sort }"
        class="flex items-center border-b-[1px] border-b-[#2F3031] px-7 py-[14px]"
      >
        <component
          :is="i.icon === 'FilterArrowDownIcon' ? FilterArrowDownIcon : FilterArrowUpIcon"
          class="fill-main stroke-main"
        />
        <span class="ml-4">{{ i.name }}</span>
      </div>
    </div>
  </div>
  <div
    v-if="selectSortDate && isMobile"
    @click.self="handleCloseSelect"
    class="fixed left-0 top-0 !z-[999] h-full w-full bg-[#000000B2]"
  >
    <div
      class="fixed bottom-0 right-0 w-full rounded-t-[30px] border-t-[1px] border-t-[#3D4043] bg-[#FFFFFF] dark:bg-[#373739]"
    >
      <div
        v-for="(i, index) in ridesDateSortOptions"
        :key="i"
        @click="handleSelectSortDate(index)"
        :class="{ 'w-full bg-[#FFFFFF08]': i.value === filterObj.sort }"
        class="flex items-center border-b-[1px] border-b-[#2F3031] px-7 py-[14px]"
      >
        <component
          :is="i.icon === 'FilterArrowDownIcon' ? FilterArrowDownIcon : FilterArrowUpIcon"
          class="fill-main stroke-main"
        />
        <span class="ml-4">{{ i.name }}</span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, onUnmounted, ref, watchEffect, computed } from 'vue'
import { useMobile } from '@/compose/ismobile'
import FilterArrowDownIcon from '@/components/ui/icons/FilterArrowDownIcon.vue'
import FilterArrowUpIcon from '@/components/ui/icons/FilterArrowUpIcon.vue'
import ArrowDownNarrowIcon from '@/components/ui/icons/ArrowDownNarrowIcon.vue'
import { storeToRefs } from 'pinia'
import { useRidesHistoryStore } from '@/stores'

const { isMobile } = useMobile()
const smallScreen = ref(window.innerWidth <= 410)
const verySmallScreen = ref(window.innerWidth <= 340)

const pages = ref([5, 10, 20, 50, 100])
const showPages = ref(5)
const selectComponent = ref(null)

const defaultNames = ref({
  selectType: 'Service type',
  selectStatus: [
    {
      name: 'Status',
      checked: true
    }
  ],
  selectRidesFilter: {
    name: 'Date descending',
    selected: true,
    icon: 'FilterArrowDownIcon',
    value: 'date_desc'
  }
})

const selectStatus = ref(false)
const selectType = ref(false)
const selectRidesFilter = ref(false)
const filterObj = ref({
  status: '',
  sort: 'date_desc',
  service_type: '',
  count: 5
})

const ridesHistoryStore = useRidesHistoryStore()
const { isRequestMessage } = storeToRefs(ridesHistoryStore)

const status = ref([
  {
    name: 'Model Selection Pending',
    checked: false,
    value: 1
  },
  {
    name: 'Payment Pending',
    checked: false,
    value: 2
  },
  {
    name: 'Waiting convert tours',
    checked: false,
    value: 3
  },
  {
    name: 'Booked',
    checked: false,
    value: 4
  }
])
const types = ref([
  {
    name: 'One Way',
    selected: false,
    value: 'One Way Transfer'
  },
  {
    name: 'Hourly',
    selected: false,
    value: 'Hourly as directed'
  },
  {
    name: 'Tours/Roadshows',
    selected: false,
    value: 'Tours / Roadshows'
  }
  // {
  //   name: 'Pick Up',
  //   selected: false
  // },
  // {
  //   name: 'Drop off',
  //   selected: false
  // }
])

const selectedServiceTypes = computed(() => types.value.filter((t) => t.selected))

watchEffect(() => {
  const params = {}

  if (filterObj.value.status) params.status = filterObj.value.status
  if (filterObj.value.sort) params.sort = filterObj.value.sort
  if (filterObj.value.service_type) params.service_type = filterObj.value.service_type
  if (filterObj.value.count) params.count = filterObj.value.count

  if (Object.keys(params).length) {
    setTimeout(() => {
      isRequestMessage.value = true
      ridesHistoryStore.loadRides(params)
    }, 500)
  }
})

const handleSetStatus = (i) => {
  const item = status.value[i]
  item.checked = !item.checked

  let statusStr = filterObj.value.status || ''
  let statusArr = statusStr ? statusStr.split(',') : []

  if (item.checked) {
    if (!statusArr.includes(String(item.value))) {
      statusArr.push(item.value)
    }

    if (!defaultNames.value.selectStatus.some((s) => s.value === item.value)) {
      defaultNames.value.selectStatus.push(item)
    }
  } else {
    statusArr = statusArr.filter((status) => status !== String(item.value))
    defaultNames.value.selectStatus = defaultNames.value.selectStatus.filter(
      (s) => s.value !== item.value
    )
  }

  if (defaultNames.value.selectStatus.length > 0) {
    defaultNames.value.selectStatus = defaultNames.value.selectStatus.filter(
      (s) => s.name !== 'Status'
    )
  }

  if (defaultNames.value.selectStatus.length === 0) {
    defaultNames.value.selectStatus.push({ name: 'Status', checked: true })
  }

  filterObj.value.status = statusArr.join(',')
}

const selectSortDate = ref(false)
const selectSortPrice = ref(false)

const ridesDateSortOptions = ref([
  {
    name: 'Date ascending',
    selected: false,
    icon: 'FilterArrowUpIcon',
    value: 'date_asc'
  },
  {
    name: 'Date descending',
    selected: true,
    icon: 'FilterArrowDownIcon',
    value: 'date_desc'
  }
])

const ridesPriceSortOptions = ref([
  {
    name: 'Price ascending',
    selected: false,
    icon: 'FilterArrowUpIcon',
    value: 'price_asc'
  },
  {
    name: 'Price descending',
    selected: true,
    icon: 'FilterArrowDownIcon',
    value: 'price_desc'
  }
])

defaultNames.value.selectSortDate = ridesDateSortOptions.value[1]
defaultNames.value.selectSortPrice = ridesPriceSortOptions.value[1]

const handleSelectSortDate = (i) => {
  ridesDateSortOptions.value.forEach((opt, index) => {
    opt.selected = index === i
  })
  defaultNames.value.selectSortDate = ridesDateSortOptions.value[i]
  filterObj.value.sort = ridesDateSortOptions.value[i].value
  selectSortDate.value = false
}

const handleSelectSortPrice = (i) => {
  ridesPriceSortOptions.value.forEach((opt, index) => {
    opt.selected = index === i
  })
  defaultNames.value.selectSortPrice = ridesPriceSortOptions.value[i]
  filterObj.value.sort = ridesPriceSortOptions.value[i].value
  selectSortPrice.value = false
}

const handleSetType = (i) => {
  const item = types.value[i]
  item.selected = !item.selected

  const selected = types.value.filter((t) => t.selected)

  filterObj.value.service_type = selected.map((s) => s.value).join(',')

  if (selected.length === 0) {
    defaultNames.value.selectType = 'Service type'
  } else if (selected.length === 1) {
    defaultNames.value.selectType = selected[0].name
  } else {
    defaultNames.value.selectType = 'Multiple selections'
  }
}

const handleOpenSelect = (value) => {
  selectType.value = false
  selectStatus.value = false
  selectRidesFilter.value = false
  selectSortDate.value = false
  selectSortPrice.value = false

  if (value === 'selectType') {
    selectType.value = true
  } else if (value === 'selectStatus') {
    selectStatus.value = true
  } else if (value === 'selectRidesFilter') {
    selectRidesFilter.value = true
  } else if (value === 'selectSortDate') {
    selectSortDate.value = true
  } else if (value === 'selectSortPrice') {
    selectSortPrice.value = true
  }
}
const handleCloseSelect = () => {
  selectStatus.value = false
  selectType.value = false
  selectRidesFilter.value = false
  selectSortDate.value = false
  selectSortPrice.value = false
}

const handleShowPages = (value) => {
  showPages.value = value
  filterObj.value.count = value
}

const handleClickOutside = (event) => {
  if (selectComponent.value && !selectComponent.value.contains(event.target)) {
    handleCloseSelect()
  }
}
onMounted(() => {
  document.addEventListener('click', handleClickOutside)
})
onUnmounted(() => {
  document.removeEventListener('click', handleClickOutside)
})
</script>

<style scoped>
input[type='checkbox'] {
  width: 15px;
  height: 15px;
  color: #5fd052 !important;
  accent-color: #5fd052 !important;
  background-color: transparent;
  border-radius: 4px;
}

input[type='checkbox']:checked {
  background-color: #5fd052 !important;
  border: 2px solid #5fd052 !important;
}

@media screen and (max-width: 345px) {
  .filter_panel {
    flex-direction: column !important;
    gap: 20px !important;
  }

  .filter_panel_type {
    border: none !important;
  }
}
</style>
